
export default {
  props: {
    testimonialLogos: {
      type: Object,
      default: () => {},
    },
  },
}
